import { render, staticRenderFns } from "./my_slide.vue?vue&type=template&id=f6014926&scoped=true"
import script from "./my_slide.vue?vue&type=script&lang=js"
export * from "./my_slide.vue?vue&type=script&lang=js"
import style0 from "./my_slide.vue?vue&type=style&index=0&id=f6014926&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6014926",
  null
  
)

export default component.exports